import { lazy } from "react";

const ResearchV2 = lazy(() => import("features/Research/v2/index"));
const StockDetailPage = lazy(() =>
  import("features/Research/v2/components/StockDetailPage")
);

// V2 Routes
// export const RESEARCH_PATH = "/research";
// export const STOCK_DETAIL_PATH = "/research/stock/:symbol/details";

export const RESEARCH_PATH = "/markets";
export const STOCK_DETAIL_PATH = "/markets/stock/:symbol/details";

export const researchRoutesV2 = [
  {
    path: RESEARCH_PATH,
    component: <ResearchV2 />,
  },
  {
    path: STOCK_DETAIL_PATH,
    component: <StockDetailPage />,
  },
];
